import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { mergeMap, Observable } from 'rxjs';
import { DeviceFirmware } from '../interfaces/allowed-device';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class DeviceFirmwareRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(deviceFirmware: DeviceFirmware): Observable<void> {
    return this.utils.routeBasedApiUrl('/deviceFirmwares', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.post<void>(url, deviceFirmware)),
      wrapError('device-firmware-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceFirmwares/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('device-firmware-repository:delete')
    );
  }

  list(): Observable<DeviceFirmware[]> {
    return this.utils.routeBasedApiUrl('/deviceFirmwares', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.get<DeviceFirmware[]>(url)),
      wrapError('device-firmware-repository:list')
    );
  }

  update(id: number, deviceFirmware: DeviceFirmware): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceFirmwares/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.put<void>(url, deviceFirmware)),
      wrapError('device-firmware-repository:update')
    );
  }
}
